/* ==========================================================================
   MaxPromo theme JS — vanilla, zero dependencies.
   ========================================================================== */
(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* --- money ------------------------------------------------------------- */
  function formatMoney(cents) {
    const fmt = (window.MP && window.MP.moneyFormat) || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  /* --- toast ------------------------------------------------------------- */
  let toastTimer;
  function toast(message) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.dataset.open = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.dataset.open = 'false'; }, 2600);
  }

  /* --- overlay + panels -------------------------------------------------- */
  let lastFocused = null;

  function openPanel(panel) {
    const overlay = $('#Overlay');
    lastFocused = document.activeElement;
    if (overlay) {
      overlay.dataset.open = 'true';
      overlay.dataset.panelSource = panel && panel.id ? panel.id : '';
    }
    panel.dataset.open = 'true';
    panel.removeAttribute('aria-hidden');
    document.body.classList.add('no-scroll');
    const focusable = panel.querySelector('button, [href], input, select, textarea');
    if (focusable) focusable.focus();
  }

  function closeAllPanels() {
    const overlay = $('#Overlay');
    if (overlay) {
      overlay.dataset.open = 'false';
      delete overlay.dataset.panelSource;
    }
    $$('[data-panel]').forEach((p) => {
      p.dataset.open = 'false';
      p.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('no-scroll');
    if (lastFocused) { lastFocused.focus(); lastFocused = null; }
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-panel-open]');
    if (opener) {
      e.preventDefault();
      const panel = document.getElementById(opener.dataset.panelOpen);
      if (panel) openPanel(panel);
      return;
    }
    if (e.target.closest('[data-panel-close]') || e.target.id === 'Overlay') {
      closeAllPanels();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllPanels();
  });

  /* --- accordions (mobile nav, facets, footer) --------------------------- */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    const panel = trigger.nextElementSibling;
    const open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!open));
    if (panel) panel.dataset.open = String(!open);
  });

  /* --- desktop category rail --------------------------------------------- */
  function initRail() {
    const navbar = $('[data-navbar]');
    if (!navbar) return;
    const toggle = $('[data-rail-toggle]', navbar);
    const rail = $('[data-rail]', navbar);
    if (!toggle || !rail) return;

    const alwaysOpen = navbar.dataset.railAlwaysOpen === 'true';
    const setOpen = (open) => {
      rail.hidden = !open;
      navbar.dataset.railOpen = String(open);
      toggle.setAttribute('aria-expanded', String(open));
    };

    setOpen(alwaysOpen);
    toggle.addEventListener('click', () => setOpen(rail.hidden));

    if (!alwaysOpen) {
      let hideTimer;
      const wrap = toggle.parentElement;
      [wrap, rail].forEach((el) => {
        el.addEventListener('mouseenter', () => { clearTimeout(hideTimer); setOpen(true); });
        el.addEventListener('mouseleave', () => { hideTimer = setTimeout(() => setOpen(false), 180); });
      });
    }
  }

  /* --- hero slider -------------------------------------------------------- */
  function initSliders() {
    $$('[data-slider]').forEach((slider) => {
      const track = $('[data-slider-track]', slider);
      const slides = $$('.slider__slide', track);
      const dots = $$('[data-slider-dot]', slider);
      if (slides.length < 2) return;

      let index = 0;
      let timer;
      const interval = parseInt(slider.dataset.autoplay, 10) || 0;

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        slides.forEach((s, n) => s.setAttribute('aria-hidden', String(n !== index)));
        dots.forEach((d, n) => d.setAttribute('aria-current', String(n === index)));
      }

      function play() {
        if (!interval) return;
        stop();
        timer = setInterval(() => go(index + 1), interval);
      }
      function stop() { clearInterval(timer); }

      $$('[data-slider-prev]', slider).forEach((b) => b.addEventListener('click', () => { go(index - 1); play(); }));
      $$('[data-slider-next]', slider).forEach((b) => b.addEventListener('click', () => { go(index + 1); play(); }));
      dots.forEach((d, n) => d.addEventListener('click', () => { go(n); play(); }));

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', play);

      // touch swipe
      let startX = null;
      slider.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; stop(); }, { passive: true });
      slider.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) go(index + (dx < 0 ? 1 : -1));
        startX = null;
        play();
      });

      go(0);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
    });
  }

  /* --- countdown ---------------------------------------------------------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach((el) => {
      const target = new Date(el.dataset.countdown).getTime();
      if (isNaN(target)) return;
      const units = {
        d: $('[data-unit="d"]', el),
        h: $('[data-unit="h"]', el),
        m: $('[data-unit="m"]', el),
        s: $('[data-unit="s"]', el)
      };
      const pad = (n) => String(n).padStart(2, '0');

      function tick() {
        let diff = Math.max(0, target - Date.now());
        const d = Math.floor(diff / 86400000); diff -= d * 86400000;
        const h = Math.floor(diff / 3600000); diff -= h * 3600000;
        const m = Math.floor(diff / 60000); diff -= m * 60000;
        const s = Math.floor(diff / 1000);
        if (units.d) units.d.textContent = pad(d);
        if (units.h) units.h.textContent = pad(h);
        if (units.m) units.m.textContent = pad(m);
        if (units.s) units.s.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* --- cart --------------------------------------------------------------- */
  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || window.MP.strings.error);
    }
    return res.json();
  }

  async function refreshCart() {
    const res = await fetch(window.MP.routes.cart + '.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    renderCartCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return cart;
  }

  function renderCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderDrawer(cart) {
    const list = $('[data-drawer-lines]');
    const totalEl = $('[data-drawer-total]');
    const empty = $('[data-drawer-empty]');
    const foot = $('[data-drawer-foot]');
    if (!list) return;

    if (!cart.items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    list.innerHTML = cart.items.map((item) => `
      <div class="cart-line">
        <img class="cart-line__img" src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : ''}" alt="" loading="lazy" width="64" height="64">
        <div>
          <a class="cart-line__name" href="${item.url}">${item.product_title}</a>
          ${item.variant_title ? `<div class="cart-line__variant">${item.variant_title}</div>` : ''}
          <div class="cart-line__variant">${formatMoney(item.final_price)} &times; ${item.quantity}</div>
          <div class="qty" style="margin-top:8px">
            <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity - 1}" aria-label="-">&minus;</button>
            <input type="number" value="${item.quantity}" min="0" data-qty-input="${item.key}" aria-label="Quantity">
            <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="+">+</button>
          </div>
          <button type="button" class="cart-line__remove" data-qty-change="${item.key}" data-qty="0">Remove</button>
        </div>
      </div>
    `).join('');

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  document.addEventListener('click', async (e) => {
    /* add to cart */
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      if (addBtn.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      const form = addBtn.closest('form');
      const id = addBtn.dataset.variantId || (form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
      if (!id) return;
      const qtyField = form && form.querySelector('[name="quantity"]');
      addBtn.setAttribute('aria-disabled', 'true');
      try {
        await cartRequest(window.MP.routes.cart_add, {
          items: [{ id: Number(id), quantity: qtyField ? Number(qtyField.value) : 1 }]
        });
        await refreshCart();
        toast(window.MP.strings.added);
        const drawer = $('#CartDrawer');
        if (drawer) openPanel(drawer);
      } catch (err) {
        toast(err.message);
      } finally {
        addBtn.removeAttribute('aria-disabled');
      }
      return;
    }

    /* quantity change in drawer / cart */
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      try {
        await cartRequest(window.MP.routes.cart_change, {
          id: qtyBtn.dataset.qtyChange,
          quantity: Number(qtyBtn.dataset.qty)
        });
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          await refreshCart();
        }
      } catch (err) { toast(err.message); }
      return;
    }

    /* stepper on product page */
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = $('[data-qty-field]', step.parentElement);
      if (input) {
        const next = Math.max(1, Number(input.value) + Number(step.dataset.qtyStep));
        input.value = next;
      }
    }
  });

  /* --- product variants --------------------------------------------------- */
  function initVariants() {
    $$('[data-product-form]').forEach((form) => {
      const dataEl = $('[data-variants-json]', form.closest('[data-product]') || document);
      if (!dataEl) return;
      const variants = JSON.parse(dataEl.textContent);
      const idField = $('[name="id"]', form);
      const priceEl = $('[data-price-current]', form.closest('[data-product]'));
      const compareEl = $('[data-price-compare]', form.closest('[data-product]'));
      if (form.dataset.mxpThemeVariantsReady === '1') return;
      form.dataset.mxpThemeVariantsReady = '1';
      const submits = Array.from(form.querySelectorAll('[data-add-to-cart]'));

      function update() {
        const chosen = $$('input[type="radio"]:checked', form).map((i) => i.value);
        const match = variants.find((v) => v.options.every((o, n) => o === chosen[n]));
        if (!match) {
          submits.forEach((submit) => { submit.setAttribute('aria-disabled', 'true'); submit.textContent = window.MP.strings.soldOut; });
          return;
        }
        if (idField) idField.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (compareEl) {
          const show = match.compare_at_price && match.compare_at_price > match.price;
          compareEl.hidden = !show;
          if (show) compareEl.textContent = formatMoney(match.compare_at_price);
        }
        submits.forEach((submit) => {
          if (match.available) { submit.removeAttribute('aria-disabled'); }
          else { submit.setAttribute('aria-disabled', 'true'); }
          submit.textContent = match.available ? submit.dataset.labelAvailable : window.MP.strings.soldOut;
        });
        if (match.featured_image) {
          const thumb = $(`[data-media-id="${match.featured_image.id}"]`);
          if (thumb) thumb.click();
        }
        const url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }

      $$('input[type="radio"]', form).forEach((input) => input.addEventListener('change', update));
      update();
    });
  }

  /* --- product gallery ---------------------------------------------------- */
  function initGallery() {
    $$('[data-gallery]').forEach((gallery) => {
      const main = $('[data-gallery-main]', gallery);
      $$('[data-gallery-thumb]', gallery).forEach((thumb) => {
        thumb.addEventListener('click', () => {
          $$('[data-gallery-thumb]', gallery).forEach((t) => t.setAttribute('aria-current', 'false'));
          thumb.setAttribute('aria-current', 'true');
          if (main) {
            main.src = thumb.dataset.full;
            main.srcset = thumb.dataset.srcset || '';
            main.alt = thumb.dataset.alt || '';
          }
        });
      });
    });
  }

  /* --- tabs --------------------------------------------------------------- */
  function initTabs() {
    $$('[data-tabs]').forEach((wrap) => {
      const tabs = $$('[role="tab"]', wrap);
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => {
            t.setAttribute('aria-selected', 'false');
            const p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = true;
          });
          tab.setAttribute('aria-selected', 'true');
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = false;
        });
      });
    });
  }

  /* --- predictive search -------------------------------------------------- */
  function initSearch() {
    const results = $('[data-predictive-results]');
    let controller;
    $$('[data-search-input]').forEach((input) => {
      let debounce;
      input.addEventListener('input', () => {
        clearTimeout(debounce);
        const q = input.value.trim();
        if (q.length < 2) { if (results) results.innerHTML = ''; return; }
        debounce = setTimeout(async () => {
          if (controller) controller.abort();
          controller = new AbortController();
          try {
            const url = `${window.MP.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search`;
            const res = await fetch(url, { signal: controller.signal });
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const inner = doc.querySelector('[data-predictive-inner]');
            if (results && inner) results.innerHTML = inner.innerHTML;
          } catch (err) { /* aborted */ }
        }, 220);
      });
    });
  }

  /* --- collection facets (auto-submit) ------------------------------------ */
  function initFacets() {
    const form = $('[data-facet-form]');
    if (!form) return;
    form.addEventListener('change', (e) => {
      if (e.target.type === 'number') return; // price inputs submit on blur instead
      form.submit();
    });
    $$('input[type="number"]', form).forEach((input) => {
      input.addEventListener('blur', () => form.submit());
    });
    const sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location = url.toString();
    });
  }

  /* --- boot --------------------------------------------------------------- */
  function boot() {
    initRail();
    initSliders();
    initCountdowns();
    initVariants();
    initGallery();
    initTabs();
    initSearch();
    initFacets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the theme editor swaps a section
  document.addEventListener('shopify:section:load', boot);
})();
